// Reducer for paymentTerm

//import actionType from './actionType';
import {
  GET_PAYMENT_TERMS_LIST,
  GET_PAYMENT_TERMS_LIST_SUCCESS,
  GET_PAYMENT_TERMS_LIST_FAILURE,
  GET_PAYMENT_TERMS_DATA,
  GET_PAYMENT_TERMS_DATA_SUCCESS,
  GET_PAYMENT_TERMS_DATA_FAILURE,
  CREATE_PAYMENT_TERMS,
  CREATE_PAYMENT_TERMS_SUCCESS,
  CREATE_PAYMENT_TERMS_FAILURE,
  UPDATE_PAYMENT_TERMS,
  UPDATE_PAYMENT_TERMS_SUCCESS,
  UPDATE_PAYMENT_TERMS_FAILURE,
  DELETE_PAYMENT_TERMS,
  DELETE_PAYMENT_TERMS_SUCCESS,
  DELETE_PAYMENT_TERMS_FAILURE,
} from "./actionType";

const initialState = {
  paymentTermsList: [],
  paymentTermsData: [],
  createPaymentTerms: [],
  updatePaymentTerms: [],
  deletePaymentTerms: [],
};

const PaymentTerm = (state = initialState, action) => {
  switch (action.type) {
    case GET_PAYMENT_TERMS_LIST:
      return {
        ...state,
      };
    case GET_PAYMENT_TERMS_LIST_SUCCESS:
      return {
        ...state,
        paymentTermsList: action.payload,
      };
    case GET_PAYMENT_TERMS_LIST_FAILURE:
      return {
        ...state,
      };
    case GET_PAYMENT_TERMS_DATA:
      return { ...state };
    case GET_PAYMENT_TERMS_DATA_SUCCESS:
      return { ...state, paymentTermsData: action.payload };
    case GET_PAYMENT_TERMS_DATA_FAILURE:
      return { ...state };
    case CREATE_PAYMENT_TERMS:
      return { ...state };
    case CREATE_PAYMENT_TERMS_SUCCESS:
      return { ...state, createPaymentTerms: action.payload };
    case CREATE_PAYMENT_TERMS_FAILURE:
      return { ...state };
    case UPDATE_PAYMENT_TERMS:
      return { ...state };
    case UPDATE_PAYMENT_TERMS_SUCCESS:
      return { ...state, updatePaymentTerms: action.payload };
    case UPDATE_PAYMENT_TERMS_FAILURE:
      return { ...state };
    case DELETE_PAYMENT_TERMS:
      return { ...state };
    case DELETE_PAYMENT_TERMS_SUCCESS:
      return { ...state, deletePaymentTerms: action.payload };
    case DELETE_PAYMENT_TERMS_FAILURE:
      return { ...state };

    default:
      return state;
  }
};

export default PaymentTerm;
